<template>
  <div>
    <v-menu
      bottom
      rounded
      offset-y
      transition="slide-y-transition"
      nudge-bottom="4"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon size="40" v-on="on" class="account-profile">
          <v-avatar size="38">
            <img
              v-if="profile.avatarFileName"
              :src="profileUrl"
              alt="profile Avatar"
            />
            <img v-else src="@/assets/images/avatars/default-avatar.jpg" />
          </v-avatar>
        </v-btn>
      </template>
      <v-card>
        <v-list-item-content class="justify-center">
          <ul class="pl-0">
            <li class="account-name text-center">
              <h6>{{ profile.firstName }} {{ profile.lastName }}</h6>
              <v-tooltip right :open-on-focus="false">
                <template v-slot:activator="{ on, attrs }">
                  <button
                    type="button"
                    class="d-flex align-center justify-center mx-auto mt-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="goSession"
                  >
                    <v-icon x-small class="pt-1">mdi-clock-outline</v-icon>
                    <p
                      dir="ltr"
                      class="p-fs-xs mb-0 ms-1 mt-1 text-p-dark"
                      v-if="userSession && userSession.length > 0"
                    >
                      <span class="p-fs-xxxs pl-1">
                        {{ label.button.lastLoginTime }}
                      </span>
                      <span> {{ userSession[1].loginTimeLocal }}</span>
                    </p>
                  </button>
                </template>
                <span>
                  {{ label.button.showMyActiveLoginTimes }}
                </span>
              </v-tooltip>
              <!-- <button
              type="button"
              class="d-flex align-center justify-center mx-auto mt-1"
            >
              <v-icon small>mdi-clock-outline</v-icon>
              <p dir="ltr" class="p-fs-xs mb-0 ms-2">
                {{ userSession[0].loginTimeLocal }}
              </p>
            </button> -->
            </li>
            <li class="account-menu-item">
              <router-link :to="{ name: 'Profile' }" class="menu-item-link">
                <i class="pi pi-user"></i>
                <h6>{{ label.menu.editProfile }}</h6>
              </router-link>
            </li>
            <li class="account-menu-item">
              <router-link :to="{ name: 'Profile' }" class="menu-item-link">
                <i class="pi pi-cog"></i>
                <h6>{{ label.menu.settings }}</h6>
              </router-link>
            </li>
            <li class="account-menu-item">
              <router-link :to="{ name: 'Profile' }" class="menu-item-link">
                <i class="pi pi-phone"></i>
                <h6>{{ label.menu.support }}</h6>
              </router-link>
            </li>
            <li class="account-menu-item" @click="logout">
              <div class="menu-item-link">
                <i class="pi pi-sign-out"></i>
                <h6>{{ label.menu.logout }}</h6>
              </div>
            </li>
          </ul>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheAccountDropDown",
  computed: {
    ...mapGetters({
      profile: "userProfile",
      userSession: "userSession",
    }),
  },
  watch: {
    profile() {
      this.profileUrl = this.fileURL + this.profile.avatarFileName;
    },
  },
  data() {
    return {
      label,
      fileURL: this.RUNTIME_ENV.VUE_APP_FILE_URL,
      profileUrl: "",
    };
  },

  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    goSession() {
      this.$router
        .push({
          name: "PBASELastLogin",
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.$store.dispatch("getUserSession");
    // this.$store.dispatch("getCurrentUser");
  },
};
</script>
